export default function collateErrors(values, props, json) {
    const { messages } = props

    if (json && json.errors) {
        const errors = {}
        json.errors.forEach(({ errorParameters, errorKey, errorMessage }) => {
            switch (errorKey) {
                case '_ERR_LOGONID_ALREDY_EXIST':
                    errors.logonId = messages.errors.userExists()
                    break
                case 'ERR_AUTHENTICATION_ERROR':
                    errors.x_logonPasswordCurrent = messages.errors.authenticationError()
                    break
                default:
                    errors._error = messages.errors.generic()
            }
        })
        return errors
    }
    return { _error: messages.errors.global() }
}
